import React from 'react'
import moment from 'moment'
import classNames from 'classnames'
import { Paragraph, Icon } from '@scentregroup/ui'
import StarRating from '../../star-rating'
import ShowMoreText from '../../show-more-text'
import { reviewType } from '../types'
import styles from './index.scss'

const MAX_STARS = 5

const mapSourceIdToSourceName = sourceId =>
  ({
    GOOGLE_PLACES: 'Google Maps',
  }[sourceId])

const ariaLabelForRating = (rating, name) => `${rating} star review by ${name}`

const Review = ({
  name,
  date,
  comment,
  rating,
  sourceId,
  responses,
  color,
  centreTitle,
}) => {
  const response = responses && responses[0]
  const responder = centreTitle || 'Replied'
  const iconWrapperClassNames = classNames(styles.iconWrapper, {
    [styles.greyIconWrapper]: color === 'White',
  })

  return (
    <div
      role="listitem"
      aria-label={ariaLabelForRating(rating, name)}
      aria-roledescription="review"
      className={styles.review}
    >
      <div className={styles.summary}>
        <div className={iconWrapperClassNames}>
          <Icon type="user" size="medium" className={styles.icon} />
        </div>

        <Paragraph className={styles.user}>
          <span className={styles.userName}>{name}</span>

          <span className={styles.source}>
            {' on '}
            {mapSourceIdToSourceName(sourceId)}
          </span>
        </Paragraph>

        <Paragraph className={styles.info}>
          <span className={styles.date}>{moment(date).fromNow()}</span>

          <span className={styles.starRating}>
            <StarRating starRating={rating} starTotal={MAX_STARS} />
          </span>
        </Paragraph>
      </div>

      <div className={styles.comment}>
        <ShowMoreText
          minLines={3}
          buttonStyle={styles.buttonStyle}
          color={color}
        >
          <Paragraph>{comment}</Paragraph>

          {response && (
            <div className={styles.response}>
              <div className={styles.responseHeading}>
                <div className={iconWrapperClassNames}>
                  <Icon
                    type="westfield-w"
                    size="medium"
                    className={styles.icon}
                  />
                </div>
                <Paragraph className={styles.westfieldName}>
                  Westfield {responder}
                </Paragraph>
              </div>
              <Paragraph>{response.comment}</Paragraph>
            </div>
          )}
        </ShowMoreText>
      </div>
    </div>
  )
}

Review.propTypes = reviewType

export default Review
